import React from "react";
import Banner from "./Banner";

const LayoutBanner = ({ children }) => {
  return (
    <div className="mt-50">
      <Banner />
      {children}
    </div>
  );
};
export default LayoutBanner;
